export default {
  mailBoxes: []
}
